import {
    InternalTransferAddTransactionDetailModelDto,
    InternalTransferAddTransactionModelDto,
    ModelBaseDto,
} from '@treasury/api/channel';

export interface AddTransactionRequest extends Omit<
    InternalTransferAddTransactionModelDto,
    keyof ModelBaseDto | 'transactions'
> {
    id?: number;
    transactions?: Omit<InternalTransferAddTransactionDetailModelDto, keyof ModelBaseDto>[];
}

export enum TransferType {
    OneToOne = 'one',
    OneToMany = 'oneToMany',
    ManyToOne = 'manyToOne',
    ManyToMany = 'many',
}
